export default __webpack_public_path__ + "static/bg-clocks--mobile-6e7399683fe8aeb34d4e252d82c1955b.webp";